<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        <span v-if="mData.viewMode == 'create'"
          >Thêm mới hướng dẫn viên đã dẫn</span
        >
        <span v-if="mData.viewMode == 'update'"
          >Cập nhật hướng dẫn viên đã dẫn</span
        >
        <span v-if="mData.viewMode == 'detail'"
          >Chi tiết hướng dẫn viên đã dẫn</span
        >
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <el-form
          :model="mData.dataForm"
          :rules="mData.validForm"
          ref="myForm"
          label-width="100%"
          label-position="top"
        >
          <b-row>
            <b-col md="2">
              <b-row>
                <b-col md="12">
                  <el-form-item
                    label="Ảnh đại diện"
                    prop="avatar_id"
                    class="mb-3"
                  >
                    <el-upload
                      action
                      :auto-upload="false"
                      list-type="picture-card"
                      :limit="mData.fileUploadOption.AnhDaiDien.limit"
                      :accept="mData.fileUploadOption.AnhDaiDien.accept"
                      :on-change="fn_uploadChangeAnhDaiDien"
                      :on-preview="fn_uploadPreviewAnhDaiDien"
                      :on-remove="fn_uploadRemoveAnhDaiDien"
                      :on-exceed="fn_uploadExceedAnhDaiDien"
                      :file-list="mData.fileUploadOption.AnhDaiDien.fileList"
                      :disabled="mData.viewMode == 'detail'"
                      :class="[
                        mData.fileUploadOption.AnhDaiDien.fileList.length > 0
                          ? 'hidden-icon-upload'
                          : '',
                      ]"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog
                      :close-on-click-modal="true"
                      :visible.sync="
                        mData.fileUploadOption.AnhDaiDien.dialogVisible
                      "
                      width="60%"
                      top="51px"
                      title="Chi tiết"
                    >
                      <img
                        width="100%"
                        :src="mData.fileUploadOption.AnhDaiDien.dialogImageUrl"
                        alt
                      />
                    </el-dialog>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>

            <b-col md="10">
              <b-row>
                <b-col md="4">
                  <el-form-item label="Họ tên" prop="ho_ten.ho_ten">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.ho_ten.ho_ten"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Ngày sinh" prop="ngay_sinh.ngay_sinh">
                    <el-date-picker
                      type="datetime"
                      v-model="mData.dataForm.ngay_sinh.ngay_sinh"
                      :format="aElement.datepicker.formatDate"
                      :valueFormat="aElement.datepicker.valueFormat"
                      :disabled="mData.viewMode == 'detail'"
                      :placeholder="aElement.datepicker.placeholderDate"
                      >clearable</el-date-picker
                    >
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Giới tính" prop="gioi_tinh">
                    <el-select
                      v-model="mData.dataForm.gioi_tinh"
                      placeholder="Chọn"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                      filterable
                    >
                      <el-option
                        v-for="item in mData.dataDefault.listGioiTinh"
                        :key="item.id"
                        :label="item.text"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <el-form-item
                    label="Quốc tịch"
                    prop="quoc_tich.ten_quoc_tich"
                  >
                    <el-input
                      v-model="mData.dataForm.quoc_tich.ten_quoc_tich"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Email" prop="email">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.email"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
                <b-col md="4">
                  <el-form-item label="Điện thoại" prop="dien_thoai">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dien_thoai"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="12">
                  <el-form-item label="Địa chỉ" prop="dia_chi.dia_chi">
                    <el-input
                      type="text"
                      v-model="mData.dataForm.dia_chi.dia_chi"
                      :disabled="mData.viewMode == 'detail'"
                      clearable
                    ></el-input>
                  </el-form-item>
                </b-col>
              </b-row>
            </b-col>
          </b-row>

          <b-row class="mt-2">
            <b-col md="12">
              <b-tabs
                card
                pills
                vertical
                v-model="tabIndex[1]"
                nav-wrapper-class="w-200"
              >
                <b-tab active>
                  <template slot="title">Thẻ hướng dẫn viên</template>
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Số thẻ" prop="the_hdv.so_the">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.the_hdv.so_the"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item
                        label="Trạng thái thẻ"
                        prop="the_hdv.trang_thai_the"
                      >
                        <el-select
                          v-model="mData.dataForm.the_hdv.trang_thai_the"
                          placeholder="Chọn"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault
                              .listTrangThaiTheHDV"
                            :key="item.code"
                            :label="item.text"
                            :value="item.code"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item label="Loại thẻ" prop="the_hdv.loai_the">
                        <el-select
                          v-model="mData.dataForm.the_hdv.loai_the"
                          placeholder="Chọn"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listLoaiTheHDV"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item label="Nơi cấp" prop="the_hdv.noi_cap">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.the_hdv.noi_cap"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Ngày cấp" prop="the_hdv.ngay_cap">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataForm.the_hdv.ngay_cap"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDatetime"
                          >clearable</el-date-picker
                        >
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Ngày hết hạn" prop="the_hdv.het_han">
                        <el-date-picker
                          type="datetime"
                          v-model="mData.dataForm.the_hdv.het_han"
                          :format="aElement.datepicker.formatDate"
                          :valueFormat="aElement.datepicker.valueFormat"
                          :disabled="mData.viewMode == 'detail'"
                          :placeholder="aElement.datepicker.placeholderDatetime"
                          >clearable</el-date-picker
                        >
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">Giấy tờ</template>
                  <b-row>
                    <b-col md="12">
                      <el-button
                        type="info"
                        plain
                        @click="fn_openModalGiayTo('create')"
                        v-if="mData.viewMode != 'detail'"
                        >Thêm giấy tờ</el-button
                      >
                    </b-col>
                  </b-row>
                  <b-row class="mt-2">
                    <div class="col-md-12">
                      <el-table
                        :data="mData.dataForm.giay_to"
                        border
                        max-height="440"
                        style="width: 100%; display: grid"
                      >
                        <el-table-column
                          prop="loai_giay_to"
                          label="Loại giấy tờ"
                          width="150"
                        ></el-table-column>
                        <el-table-column
                          prop="so_giay_to"
                          label="Số giấy tờ"
                          width="auto"
                          min-width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="noi_cap"
                          label="Nơi cấp"
                          width="150"
                        ></el-table-column>
                        <el-table-column
                          prop="ngay_cap"
                          label="Ngày cấp"
                          :formatter="fn_formatterDate"
                          width="150"
                          align="center"
                        ></el-table-column>
                        <el-table-column
                          prop="ngay_het_han"
                          label="Ngày hết hạn"
                          :formatter="fn_formatterDate"
                          width="150"
                          align="center"
                        ></el-table-column>

                        <el-table-column
                          label="Thao tác"
                          align="center"
                          width="200px"
                          v-if="mData.viewMode != 'detail'"
                        >
                          <template slot-scope="scope">
                            <el-button
                              size="mini"
                              @click="
                                fn_openModalGiayto(
                                  'update',
                                  scope.$index,
                                  scope.row
                                )
                              "
                              v-b-tooltip.hover
                              :title="'Cập nhật'"
                            >
                              <i class="icon-pencil icons"></i>
                            </el-button>
                            <el-button
                              size="mini"
                              @click="
                                fn_handleGioiTo(
                                  'delete',
                                  scope.$index,
                                  scope.row
                                )
                              "
                              v-b-tooltip.hover
                              :title="'Xóa'"
                            >
                              <i class="icon-trash icons"></i>
                            </el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </b-row>
                </b-tab>
                <b-tab>
                  <template slot="title">Thông tin bổ sung</template>
                  <b-row>
                    <b-col md="6">
                      <el-form-item label="Ngoại ngữ" prop="ngoai_ngu">
                        <el-select
                          v-model="mData.dataForm.ngoai_ngu"
                          placeholder="Chọn"
                          :disabled="mData.viewMode == 'detail'"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listNgoaiNgu"
                            :key="item.id"
                            :label="item.name.vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Sở trường" prop="so_truong">
                        <el-select
                          v-model="mData.dataForm.so_truong"
                          placeholder="Chọn"
                          :disabled="mData.viewMode == 'detail'"
                          multiple
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in mData.dataDefault.listSoTruong"
                            :key="item.id"
                            :label="item.name.vi"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item label="Thành tích" prop="thanh_tich">
                        <el-input
                          type="text"
                          v-model="mData.dataForm.thanh_tich"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item
                        label="Số tour đã hướng dẫn"
                        prop="tong_so_tour"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.tong_so_tour"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>

                    <b-col md="6">
                      <el-form-item
                        label="Lịch sử hành nghề"
                        prop="lich_su_hanh_nghe"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.lich_su_hanh_nghe"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="6">
                      <el-form-item
                        label="Số năm hành nghề"
                        prop="so_nam_hanh_nghe"
                      >
                        <el-input
                          type="text"
                          v-model="mData.dataForm.so_nam_hanh_nghe"
                          :disabled="mData.viewMode == 'detail'"
                          clearable
                        ></el-input>
                      </el-form-item>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>

              <!-- end tab -->
            </b-col>
          </b-row>

          <el-form-item class="text-center mt-3">
            <el-button
              type="info"
              plain
              @click="fn_submitForm('create')"
              v-ladda
              v-if="mData.viewMode == 'create'"
              >Thêm mới</el-button
            >

            <el-button
              type="info"
              plain
              @click="fn_submitForm('update')"
              v-ladda
              v-if="mData.viewMode == 'update'"
              >Cập nhật</el-button
            >

            <el-button @click="fn_go()" type="info" plain>Quay lại</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import DataService from "../../../service/DataService";
import MethodService from "../../../service/MethodService";
// import ProvinceApi from "../../../moduleApi/ProvinceApi";
import ExtensionService from "../../../service/ExtensionService";
import HuongDanVienModel from "./HuongDanVienModel";
import mushroom from "../../../service/api/dulich-api";

export default {
  data() {
    return {
      aElement: MethodService.element,
      tabIndex: [0, 0],
      mData: {
        viewMode: "create",
        moduleName: "HuongDanVienDaDan",
        dataDefault: {
          roles: DataService.rolesInForm,
          listProvince: [],
          listDistrict: [],
          listKhachDuLich: [],
          listHuongDanVien: [],
          listCongTyLuHanh: [],
          listTour: [],
          listLoaiGiayTo: DataService.loaiGiayTo,
          listGioiTinh: DataService.gioiTinh,
          listSoTruong: [],
          listNgoaiNgu: [],
          listLoaiTheHDV: DataService.loaiTheHDV,
          listTrangThaiTheHDV: DataService.trangThaiTheHDV,
          listLoaiDinhDang: DataService.loaiDinhDang,
          // listQuocTich:[],
          GiayTo: {
            viewMode: "create",
            indexModal: undefined,
          },
        },
        dataForm: MethodService.copyObject(HuongDanVienModel.dataForm),
        validForm: HuongDanVienModel.validForm,
        dataFormGiayTo: MethodService.copyObject(
          HuongDanVienModel.dataFormOther.giay_to
        ),
        validFormGiayTo: HuongDanVienModel.validFormOther.giay_to,

        dialog: {
          GiayTo: false,
        },
        fileUploadOption: {
          AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: [],
          },
        },
      },
    };
  },
  methods: {
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          if (type == "create") {
            await mushroom.huong_dan_vien.createAsync(this.mData.dataForm);
            this.fn_resetForm();
          }
          if (type == "update") {
            this.mData.dataForm.id = this.$router.currentRoute.params.id;
            await mushroom.huong_dan_vien.partialUpdateAsync(
              this.mData.dataForm
            );
            this.fn_go(-1);
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    fn_resetFormGiayTo() {
      this.$refs["myFormGiayTo"].resetFields();
    },
    fn_go() {
      this.$router.go(-1);
    },
    async fn_getDataById(id) {
      let res = await mushroom.huong_dan_vien.findByIdAsync({
        id: id,
        fields:
          "id,ho_ten,email,dien_thoai,gioi_tinh,ngay_sinh,giay_to,quoc_tich,dia_chi,avatar_id,the_hdv,ngoai_ngu,so_truong,thanh_tich,lich_su_hanh_nghe",
      });

      if (res.result.ngay_sinh && res.result.ngay_sinh.nam) {
        res.result.ngay_sinh.ngay_sinh = new Date(
          res.result.ngay_sinh.nam,
          res.result.ngay_sinh.thang - 1,
          res.result.ngay_sinh.ngay
        ).toUTCString();
      }

      // let resTongSoTour = await TourApi.getTourCountByTourGuideIds(
      // res.result.id
      // );
      let resTongSoTour =
        await mushroom.tour.views.getTourCountByTourGuideIdsAsync({
          hdv_ids: [res.result.id],
        });

      let itemSoTour = resTongSoTour.result;
      if (itemSoTour) {
        res.result.tong_so_tour = itemSoTour[0].count;
      }

      if (
        !res.result.the_hdv ||
        res.result.the_hdv.het_han == undefined ||
        res.result.the_hdv.het_han == null
      ) {
        if (!res.result.the_hdv) res.result.the_hdv = {};
        res.result.the_hdv.trang_thai_the = "not_active";
      } else {
        if (new Date() > new Date(res.result.the_hdv.het_han)) {
          res.result.the_hdv.trang_thai_the = "expired";
        } else {
          res.result.the_hdv.trang_thai_the = "active";
        }
      }

      if (res.result.the_hdv && res.result.the_hdv.ngay_cap) {
        var ngayHienTai = new Date();
        var ngayCap = new Date(res.result.the_hdv.ngay_cap);
        res.result.so_nam_hanh_nghe =
          ngayHienTai.getFullYear() - ngayCap.getFullYear();
        if (res.result.so_nam_hanh_nghe < 1) {
          res.result.so_nam_hanh_nghe = "Dưới 1 năm";
        }
      }

      // Đảm bảo các nested object luôn có giá trị mặc định
      if (!res.result.quoc_tich) {
        res.result.quoc_tich = { quoc_tich_id: null, ten_quoc_tich: null };
      }
      if (!res.result.ho_ten) {
        res.result.ho_ten = {
          ten: null,
          ho: null,
          ho_ten: null,
          dinh_dang: null,
        };
      }
      if (!res.result.ngay_sinh) {
        res.result.ngay_sinh = {
          ngay: null,
          thang: null,
          nam: null,
          ngay_sinh: null,
        };
      }
      if (!res.result.dia_chi) {
        res.result.dia_chi = {
          province_id: null,
          province_name: null,
          district_id: null,
          district_name: null,
          dia_chi: null,
        };
      }
      if (!res.result.the_hdv) {
        res.result.the_hdv = {
          so_the: null,
          loai_the: null,
          ngay_cap: null,
          noi_cap: null,
          het_han: null,
        };
      }

      this.mData.dataForm = res.result;
      if (this.mData.dataForm.avatar_id) {
        let data = {
          id: this.mData.dataForm.avatar_id,
          name: this.mData.dataForm.avatar_id,
          url: ExtensionService.urlImg + this.mData.dataForm.avatar_id,
        };
        this.mData.fileUploadOption.AnhDaiDien.fileList.push(data);
      }
    },
    async fn_initDataDefault() {
      let reqCongTyLuHanhApi = mushroom.tv_cong_ty_lu_hanh.listAsync({
        limit: 1000,
      });
      let reqTourApi = mushroom.tour.listAsync({ limit: 1000 });
      let reqSoTruongApi = mushroom.so_truong.listAsync({ limit: 1000 });
      let reqNgoaiNguApi = mushroom.ngoai_ngu.listAsync({ limit: 1000 });

      let resCongTyLuHanhApi = await reqCongTyLuHanhApi;
      let resTourApi = await reqTourApi;
      let resSoTruongApi = await reqSoTruongApi;
      let resNgoaiNguApi = await reqNgoaiNguApi;

      this.mData.dataDefault.listCongTyLuHanh = resCongTyLuHanhApi.result;
      this.mData.dataDefault.listTour = resTourApi.result;

      this.mData.dataDefault.listSoTruong = resSoTruongApi.result;
      this.mData.dataDefault.listNgoaiNgu = resNgoaiNguApi.result;
    },

    // giấy tờ
    fn_handleGiayTo(type, index) {
      if (type == "create") {
        this.$refs["myFormGiayTo"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormGiayTo);
            this.mData.dataForm.hanh_trinh.push(item);
            this.fn_resetFormGiayTo();
            this.mData.dialog.GiayTo = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "update") {
        this.$refs["myFormGiayTo"].validate(async (valid) => {
          if (valid) {
            let item = MethodService.copyObject(this.mData.dataFormGiayTo);
            this.mData.dataForm.hanh_trinh[
              this.mData.dataDefault.GiayTo.indexModal
            ] = item;
            this.fn_resetFormGiayTo();
            this.mData.dialog.GiayTo = false;
            MethodService.stopLadda();
          } else {
            MethodService.stopLadda();
            return false;
          }
        });
      }
      if (type == "delete") {
        this.$confirm("Bạn có chắc chắn muốn xóa bản ghi này không?", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Huỷ",
          type: "warning",
        })
          .then(() => {
            this.mData.dataForm.hanh_trinh.splice(index, 1);
          })
          .catch(() => {});
      }
    },
    fn_openModalGiayTo(type, id) {
      this.mData.dialog.GiayTo = true;
      if (type == "create") {
        this.mData.dataDefault.GiayTo.indexModal = undefined;
        this.mData.dataDefault.GiayTo.viewMode = type;
        this.mData.dataFormGiayTo = MethodService.copyObject(
          HuongDanVienModel.dataFormOther.giay_to
        );
      } else {
        this.mData.dataDefault.GiayTo.indexModal = id;
        this.mData.dataDefault.GiayTo.viewMode = type;
        this.mData.dataFormGiayTo = MethodService.copyObject(
          this.mData.dataForm.giay_to[id]
        );
      }
    },

    fn_formatterDate(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "date");
    },

    fn_formatterDatetime(row, column, cellValue, index) {
      return MethodService.formatDate(cellValue, "datetime");
    },

    //upload ảnh
    fn_uploadCheckFileSize(file) {
      return MethodService.checkFileSize(file, 3);
    },

    fn_uploadRemoveAnhDaiDien(file, fileList) {
      this.mData.dataForm.anh.anh_dai_dien = null;
      this.mData.fileUploadOption.AnhDaiDien.fileList = [];
    },
    fn_uploadChangeAnhDaiDien(file, fileList) {
      ExtensionService.upload(file, "huongDanVien")
        .then((res) => {
          this.mData.dataForm.anh.anh_dai_dien = res.result;
          this.mData.fileUploadOption.AnhDaiDien.fileList = fileList;
        })
        .catch((error) => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedAnhDaiDien(files, fileList) {
      toastr.info(
        `Chỉ tải lên tối đa ${this.mData.fileUploadOption.AnhDaiDien.limit} file`
      );
    },
    fn_uploadPreviewAnhDaiDien(file) {
      this.mData.fileUploadOption.AnhDaiDien.dialogImageUrl = file.url;
      this.mData.fileUploadOption.AnhDaiDien.dialogVisible = true;
    },
  },

  created: function () {
    this.fn_initDataDefault();
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-update"
    ) {
      this.mData.viewMode = "update";
    }
    if (
      this.$router.currentRoute.name ==
      "Admin-" + this.mData.moduleName + "-detail"
    ) {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted: function () {},
};
</script>
